import React from 'react';
import { Row, Col} from 'reactstrap';
import SetUpDeliveries from '../../../Shared/SetUpDeliveries/SetUpDeliveries';

const DeliveryAddressTypes = (props) => {
  return (
    <div>
      <div className='container-fluid main'>
        <div className='setup-address'>
          <Row>
            <Col ms={12}>
              <SetUpDeliveries selectedAddress={props.selectedAddress} title='כתובת מגורים' />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DeliveryAddressTypes;
